import * as R from 'ramda';

import { LocationDataTitle, TaskLocation } from '@atom/types/taskLocation';

import classes from './workOrderReport.module.css';

interface Props {
  rowLocations: TaskLocation[];
}

const LocationsRow = ({ rowLocations }: Props) => {
  const convertNumberToLocaleString = (input: string | number): string => {
    return R.isNil(input) ? '' : Number(input).toLocaleString('en-US');
  };

  return (
    <div className={classes.locationRowContainer}>
      {rowLocations.map(location => {
        const route =
          location?.data.find(item => item.title === LocationDataTitle.ROUTE)
            ?.value || '';

        const direction =
          location?.data.find(
            item => item.title === LocationDataTitle.DIRECTION,
          )?.value || '';

        const startMilepost = location?.data.find(
          item => item.title === LocationDataTitle.START_MILEPOST,
        )?.value;

        const endMilepost = location?.data.find(
          item => item.title === LocationDataTitle.END_MILEPOST,
        )?.value;

        return (
          <div className={classes.locationRow}>
            <div>{route}</div>
            <div className={classes.locationRowSub}>
              <div className={classes.locationCell}>{direction}</div>
              <div className={classes.locationCell}>
                {convertNumberToLocaleString(startMilepost)}
              </div>
              <div className={classes.locationCell}>
                {convertNumberToLocaleString(endMilepost)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LocationsRow;
